import NoPmEventsIcon from "@shared/svg/no-pm-events.svg?react";
import NoTicketsIcon from "@shared/svg/no-tickets.svg?react";
import { AlertBox } from "@shared/ui/AlertBox";
import BodyText, { BODY_TEXT_SIZES } from "@shared/ui/BodyText";
import Button from "@shared/ui/Button";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import getEnum from "$/settings/enums";
import PAID_FEATURES from "$/settings/paid-features";
import useAuth from "~/components/general/_use-auth";
import { INITIATE_ADD_PREVENTIVE_MAITENANCE_EVENT } from "~/constants";
import { usePMEMessages } from "~/containers/plannedEvents/helpers";
import { registerMixpanelEvent } from "~/utils/_mixpanel";
import { useGetAppConfigValue } from "~/utils/appFeatures";
import isPaidFeatureAvailable from "~/utils/isPaidFeatureAvailable";

export default function NoPMScheduled({
  addEventCallback,
  canCreate,
  isSharedAssetsPage,
}) {
  const {
    messages: { preventiveMaintenance: PM },
  } = useIntl();
  const [showAlert, setShowAlert] = useState(false);
  const { user } = useAuth();
  const PaidFeatures = getEnum(PAID_FEATURES, "reference");
  const appConfig = useGetAppConfigValue();

  const isFeatureAccessible = isPaidFeatureAvailable(
    PaidFeatures.preventiveMaintenance,
    user,
    appConfig,
  );

  const { description = "" } = usePMEMessages();
  const canShowCTA = canCreate && !isSharedAssetsPage;

  const handleCreateClick = (e) => {
    registerMixpanelEvent(INITIATE_ADD_PREVENTIVE_MAITENANCE_EVENT);
    if (isFeatureAccessible) {
      return addEventCallback(e);
    }
    return setShowAlert(true);
  };

  return (
    <div className="flex w-full flex-col items-center justify-center gap-y-lg text-center min-h-[calc(100vh-400px)]">
      <NoPmEventsIcon className="mb-lg" />
      {description && (
        <BodyText
          size={BODY_TEXT_SIZES.MEDIUM}
          color="text-secondary"
          className="max-w-[420px]"
        >
          {description}
        </BodyText>
      )}
      {canShowCTA && (
        <Button text={PM?.createEventButtonText} onClick={handleCreateClick} />
      )}

      <AlertBox
        acceptButtonText={PM?.noPMAlertOkayButton}
        image={<NoTicketsIcon width="130" height="130" />}
        alertContent={
          <Headline size={HEADLINE_SIZES.X_SMALL}>
            {PM?.noPMAlertTitle}{" "}
            <a
              href={`mailto:${PM?.noPMAlertTitleEmail}`}
              className="text-brand"
            >
              {PM?.noPMAlertTitleEmail}
            </a>
          </Headline>
        }
        onAccept={() => setShowAlert(false)}
        overlay
        isOpen={showAlert}
      />
    </div>
  );
}
